'use client';

import { useMemo } from "react";

import ListListingSearch from "@src/components/molecules/list-listing-office/list-listing-office-search";
import ListListingFilter from "@src/components/molecules/list-listing-office/list-listing-office-filter";
import ListListingFilterJualBeli from "@src/components/molecules/list-listing-office/list-listing-office-filter-jual-beli";
import ListListingSelectedCategory from "@src/components/molecules/list-listing-office/list-listing-office-selected-category";
import ListListingPropertyGrid from "@src/components/molecules/list-listing-office/list-listing-office-property-grid";
import Footer from "@src/components/organism/shared/footer-office";

// Api
import useListListingCtx from "@src/context/list-listing-office-ctx";

const ListListing = () => {
  const { listListing, params, listPropertyCategories, searchDisplay } = useListListingCtx()

  const totalListing = useMemo(() => {
    if (!listListing?.pages?.length) return []

    return listListing.pages[0]?.headers?.["x-total"] ?? 0
  }, [listListing])

  const selectedCategory = useMemo(() => {
    if (!listPropertyCategories?.length) return null;

    return listPropertyCategories.find(d => d.id === +params.property_category_id) ?? {};
  }, [params, listPropertyCategories]);

  const selectedSort = useMemo(() => {
    if (!params["_order"]) return "";

    if (params["_order"] === "highest-price") {
      return "Harga Tinggi ke Rendah"
    }

    if (params["_order"] === "lowest-price") {
      return "Harga Rendah ke Tinggi"
    }

    return ""
  }, [params]);

  return (
    <div className="section-container overflow-x-hidden 
      dd2-xl:pb-32">
      <div className="w-full bg-[#E6E7E8] py-4 pb-2 flex justify-center 
        dd2-xl:hidden">
        <div className="px-[48px] w-full max-w-[1344px] flex items-center justify-between 
        dd2-2xl:px-4 ">
          <div className="flex items-center gap-2">
            <ListListingFilterJualBeli />
            <ListListingSearch />
            <ListListingSelectedCategory />
          </div>
          <ListListingFilter />
        </div>
      </div>

      <div className="hidden w-full bg-[#E6E7E8] flex-col justify-center 
        dd2-xl:flex">
        <div className="my-2 px-4">
          <ListListingSearch />
        </div>
        <div className="w-full bg-white px-4 py-2 items-center justify-between flex">
          <div className="flex items-center gap-2">
            <ListListingFilterJualBeli />
            <ListListingSelectedCategory />
          </div>
          <ListListingFilter />
        </div>

        <div className="div-1" />
      </div>

      {!!totalListing && <div className="py-[32px] w-full px-6 max-w-[1344px] flex items-center justify-between dd2-xl:hidden">
        <p className="text-[14px] font-satoshi text-[#808285]">Menampilkan <span className="text-[#252526] font-satoshi-bold">+{totalListing} {selectedCategory?.name ?? "property"} {params.property_type_id === 1 ? "dijual" : params.property_type_id === 2 ? "disewa" : ""} </span> di <span className="text-[#252526] font-satoshi-bold">{searchDisplay || "Indonesia"}</span></p>
        {!!selectedSort && <p className="text-[14px] font-satoshi text-[#808285]">Diurut berdasarkan <span className="text-[#252526] font-satoshi-bold">{selectedSort}</span></p>}
      </div>}

      {!!totalListing && <div className="py-4 w-full px-6 hidden items-center justify-center 
      dd2-xl:flex">
        <p className="text-[14px] font-satoshi text-[#808285] text-center">Menampilkan <span className="text-[#252526] font-satoshi-bold">+{totalListing} {selectedCategory?.name ?? "property"} {params.property_type_id === 1 ? "dijual" : params.property_type_id === 2 ? "disewa" : ""} </span> di <span className="text-[#252526] font-satoshi-bold">{searchDisplay || "Indonesia"}</span> {!!selectedSort && <>dari <span className="text-[#252526] font-satoshi-bold">{selectedSort}</span></>}</p>
      </div>}

      <div className="w-full px-4 max-w-[1344px]">
        <ListListingPropertyGrid />
      </div>

      <Footer />
    </div>
  )
}

export default ListListing
